import script from "./BookingPublicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingPublicPage.vue?vue&type=script&setup=true&lang=js"

import "./BookingPublicPage.vue?vue&type=style&index=0&id=a9df96de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9df96de"]])

export default __exports__